<template>
    <div id="app">
        <!-- 路由占位符 -->
        <router-view />
    </div>
</template>

<script>
export default {
    components: {},
    data() {
        return {}
    },

    created() {},
    beforeDestroy() {},
    methods: {}
}
</script>

<style lang="less">
#app {
    height: 100vh; /* 固定高度 */
    overflow: hidden; /* 禁止app级别滚动 */
}
</style>
